var _g, _rect, _rect2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTildiBarcodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 21,
    viewBox: "0 0 27 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1277_11160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.8999 0V17",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0V17",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0V17",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 0V17",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7998 0V17",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 0V17",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8501 0V17",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.44971 0V17",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4502 0V17",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8501 0V17",
    stroke: "white",
    strokeWidth: 0.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.25,
    y: 11.25,
    width: 9.5,
    height: 9.5,
    rx: 4.75,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.25,
    y: 11.25,
    width: 9.5,
    height: 9.5,
    rx: 4.75,
    stroke: "#405C43",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0833 15.5833H22.4167V13.9167C22.4167 13.8062 22.3728 13.7002 22.2946 13.622C22.2165 13.5439 22.1105 13.5 22 13.5C21.8895 13.5 21.7835 13.5439 21.7054 13.622C21.6272 13.7002 21.5833 13.8062 21.5833 13.9167V15.5833H19.9167C19.8062 15.5833 19.7002 15.6272 19.622 15.7054C19.5439 15.7835 19.5 15.8895 19.5 16C19.5 16.1105 19.5439 16.2165 19.622 16.2946C19.7002 16.3728 19.8062 16.4167 19.9167 16.4167H21.5833V18.0833C21.5833 18.1938 21.6272 18.2998 21.7054 18.378C21.7835 18.4561 21.8895 18.5 22 18.5C22.1105 18.5 22.2165 18.4561 22.2946 18.378C22.3728 18.2998 22.4167 18.1938 22.4167 18.0833V16.4167H24.0833C24.1938 16.4167 24.2998 16.3728 24.378 16.2946C24.4561 16.2165 24.5 16.1105 24.5 16C24.5 15.8895 24.4561 15.7835 24.378 15.7054C24.2998 15.6272 24.1938 15.5833 24.0833 15.5833Z",
    fill: "#405C43"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1277_11160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTildiBarcodeIcon);
export default __webpack_public_path__ + "static/media/tildi-barcode-icon.69fe1f1c5f21cee7c3811688b59ac863.svg";
export { ForwardRef as ReactComponent };